"use client";
import { forwardRef } from "react";
import AppSnackbar from "./AppSnackbar";
import { SnackbarTypeEnum } from "@/models";
import { CustomContentProps } from "notistack";

const AppSnackbarSuccess = forwardRef<
  HTMLDivElement,
  CustomContentProps & { type?: SnackbarTypeEnum }
>(({ type = SnackbarTypeEnum.Success, ...props }, ref) => {
  return <AppSnackbar {...props} type={type} ref={ref} />;
});

AppSnackbarSuccess.displayName = "AppSnackbarSuccess";
export default AppSnackbarSuccess;
